module.exports = __webpack_public_path__ + "img/sotg_cover.286fc95e.jpg";